import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { ProductAttribute } from '../../interfaces/interfaces';
import { ProductattributedeleteComponent } from '../productattributedelete/productattributedelete.component';
import { ProductattributeeditorComponent } from '../productattributeeditor/productattributeeditor.component';

@Component({
  selector: 'app-productattributes',
  templateUrl: './productattributes.component.html',
  styleUrls: ['./productattributes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductattributesComponent extends SimpleTableComponent<ProductAttribute> {

  showProductAttributeEditorModal(productAttribute: ProductAttribute|null = null): void {
    this.dialogService.open(ProductattributeeditorComponent, {
      header: productAttribute !== null ? 'Termék attribútum szerkesztése - ' + productAttribute.name : 'Termék attribútum hozzáadása',
      data: {
        productAttributeId: productAttribute !== null ? productAttribute.id : null
      },
      width: '70vw'
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  showProductAttributeDeleteModal(productAttribute: ProductAttribute|null = null): void {
    if (productAttribute === null) {
      return;
    }
    this.dialogService.open(ProductattributedeleteComponent, {
      header: 'Termék attribútum törlése - ' + productAttribute.name,
      data: {
        productAttributeId: productAttribute.id
      },
      width: '500px'
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  constructor(
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef,
    private apiServiceRef: ApiService
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'attributes';
  }

}
